// extracted by mini-css-extract-plugin
export default {"layout":"_4b26caeaf0 _1cea8960fe _25256b2c77","h_slide":"_7faefab7b7","category":"_2aa296c098 _9325e9af19 _5f783f028c"};